import {EditableFieldModel} from "@white-label/components/page-builder/models/edit-component.model";
import {FieldType} from "@white-label/components/page-builder/models/model.map";
import {CardModel, CardTypes} from "@white-label/components/page-builder/models/card.model";

export class CardGridModel {
    cards = new EditableFieldModel('card', FieldType.array, [
        new CardModel(),
        new CardModel(),
        new CardModel(),
        new CardModel(),
        new CardModel(),
        new CardModel(),
    ], CardModel);
    columnsXl = new EditableFieldModel('Columns for PC', FieldType.number, 3);
    columnsMd = new EditableFieldModel('Columns for tablet', FieldType.number, 2);
    cardComponent = new EditableFieldModel('Choose feature showcase', FieldType.cardType, CardTypes.blog);
    fieldsMap = [this.cards, this.columnsXl, this.columnsMd, this.cardComponent];

    constructor(data?: {cards?: any, columnsXl?: any, columnsMd?: any, spacing?: any,  cardComponent?: any}) {
        if(data?.cards){
            this.cards.value = [];
            for(let banner of data?.cards.value){
                this.cards.value.push(new CardModel(banner));
            }
        }
        if(data?.columnsMd?.value){
            this.columnsMd.value = data?.columnsMd.value;
        }
        if(data?.columnsXl?.value){
            this.columnsXl.value = data?.columnsXl.value;
        }
        if(data?.cardComponent?.value){
            this.cardComponent.value = data?.cardComponent.value;
        }
    }
}